import React , {useState} from 'react'
import styled from '@emotion/styled'
import {obtenerDiferencia, calcularMarca,obtenerPlan} from '../helper' 

const Campo = styled.div `
    display: flex;
    margin-bottom: 1rem;
    align-items: center;
`
const Label = styled.label`
    flex : 0 0 100px;
`
const Select = styled.select`
    display: block;
    width: 100%;
    padding: 1rem;
    border: 1px solid #e1e1e1;
    -webkit-appearance: none;
`

const InputRadio = styled.input`
    margin : 0 1rem;
`
const Boton = styled.button`
    background-color: #00838F;
    font-size: 16px;
    width:100%;
    padding: 1rem;
    color : #fff;
    text-transform: uppercase;
    font-weight: bold;
    border: none;
    transition : background-color .3s ease;
  

    &:hover{
        cursor: pointer;
        background-color: #26CDAD;
    }
`
const Error = styled.div`
    background-color: red;
    color : white;
    padding: 1rem;
    width: 100%;
    text-align: center;
    margin-bottom: 2rem;
`
const Formulario = ({guardarResumen, guardarCargando}) => {

    const [datos , guardarDatos] = useState ({
        marca : '',
        year: '',
        plan : ''
    });

    const [error , guardarError] = useState(false);

    // extraer datos 

    const {marca , year , plan } = datos;

    // leer datos del form y colocar en el state

    const obtenerInformacion = e =>{
         guardarDatos({
            ...datos,
            [e.target.name] : e.target.value
         })
    }

    // cuando el usuario presione submit

    const cotizarSeguro = e =>{
        e.preventDefault();


        if(marca.trim()=== '' || year.trim()=== '' || plan.trim()=== ''){
            guardarError(true)
            return;
        }
        guardarError(false);
        // una base de 2000

        let resultado = 500;

        // obtener la diferencia de años
        const diferencia = obtenerDiferencia(year);

        // por cada año hay que restar el 3%
        resultado -=((diferencia * 3)*resultado) /100;

        // rimac 15

        // mapfre 5%

        // pacifico 30%

        resultado = calcularMarca(marca) *resultado;
         //basico aumenta 20%
         // comlpleto 50%
        const incrementoPlan = obtenerPlan(plan);
         // total
        // le damos el parse floar porque queremos que dar decimales y ademas una canitad expecifica de los mismos.
          resultado = parseFloat(incrementoPlan * resultado).toFixed(2);
         guardarCargando(true);

         setTimeout(() => {
            guardarCargando(false)
            guardarResumen({
                cotizacion : Number(resultado),
                datos
            })
         }, 3000);
         
    }
    return (  

        <form onSubmit={cotizarSeguro}>
            {error ?<Error>Todos los campos son obligatarios</Error> : null}
            <Campo>
                <Label>Seguro de preferencia</Label>
                <Select
                    name = "marca"
                    value= {marca}
                    onChange={obtenerInformacion}
                >
                   <option value="">-- Seleccione --</option> 
                   <option value="rimac">Rimac</option> 
                   <option value="pacifico">Pacífico </option> 
                   <option value="mapfre">Mapfre</option> 

                </Select>
            </Campo>
            <Campo>
                <Label>Año</Label>
                <Select  
                    name = "year"
                    value= {year}
                    onChange={obtenerInformacion}

                    >
                    <option value="">-- Seleccione --</option>
                    <option value="2021">2021</option>
                    <option value="2020">2020</option>
                    <option value="2019">2019</option>
                    <option value="2018">2018</option>
                    <option value="2017">2017</option>
                    <option value="2016">2016</option>
                    <option value="2015">2015</option>
                    <option value="2014">2014</option>
                    <option value="2013">2013</option>
                    <option value="2012">2012</option>
                </Select>
            </Campo>
            <Campo>
                <Label>Plan</Label>
                <InputRadio type="radio"
                       name = "plan"
                       value= "basico"
                       checked={plan ==="basico"}
                        onChange={obtenerInformacion}

                       />basico
                <InputRadio type="radio"
                       name = "plan"
                       value= "completo"
                       checked={plan ==="completo"}
                        onChange={obtenerInformacion}

                       />Completo
                
                
            </Campo>
            <Boton type="submit">Cotizar</Boton>
            
        </form>
    );
}
 
export default Formulario;